import React, { useState } from "react";
import dcMapOld from "../../images/reflectingPool/questions/dcMapOld.jpg"
import dcMapNew from "../../images/reflectingPool/questions/dcMapNew.jpg"
import Slider from "@mui/material/Slider";
import { Box } from "@mui/material";
import {Flex} from "reflexbox";
import Typography from "@mui/material/Typography";
import {PRIMARYCOLOR} from "../helpers/ThemeSettings";
import Skeleton from "@mui/material/Skeleton";
import Tooltip from "@mui/material/Tooltip";
import {useImageLoad} from "../../helpers/helpers";

const DCMapOverlap = ({
  oldMapSrc = dcMapOld,
  newMapSrc = dcMapNew,
  oldAlt = "Old Map of DC",
  newAlt = "New Map of DC",
  descriptionTop = "Most of the area of today's course used to be covered by the Potomac River or marshland. In the early 1900s, the National Mall was extended using landfill. Toggle the map below to see how the area has changed!",
  descriptionBottom = "A system of canals meant that you could float right up to the Capitol Building in a boat! The Tiber Creek, which used to feed the canal, still flows underneath the city in tunnels.",
  leftLabel = "Historical",
  rightLabel = "Current",
}) => {
  const [opacity, setOpacity] = useState(50);
  const [tt, setTt] = useState(true);
  const {imgRef, loaded, onLoad, onError, showSkeleton} = useImageLoad(oldMapSrc);

  return (
    <>
      <Typography style={{ paddingBottom: "16px" }}>
        {descriptionTop}
      </Typography>
      <Box position="relative" width="100%">
        {showSkeleton && (
          <Skeleton variant="rect" height="280px" width="100%" />
        )}
        <img
          ref={imgRef}
          id="overlap-old-map"
          onLoad={onLoad}
          onError={onError}
          src={oldMapSrc}
          alt={oldAlt}
          style={{
            width: "100%",
            display: "block",
            opacity: loaded ? 1 : 0,
            position: showSkeleton ? "absolute" : "static",
            top: showSkeleton ? 0 : undefined,
            left: showSkeleton ? 0 : undefined,
          }}
        />
        {loaded && (
          <img
            src={newMapSrc}
            alt={newAlt}
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              opacity: opacity / 100,
            }}
          />
        )}
      </Box>

      <Flex
        id={"Slider"}
        style={{
          width: "100%",
          justifyContent: "space-between",
          paddingTop: "8px",
        }}
      >
        <Typography
          style={{
            minWidth: "86px",
            textAlign: "center",
            color: PRIMARYCOLOR,
            fontWeight: "bold",
          }}
        >
          {leftLabel}
        </Typography>
        <div style={{ maxWidth: "150px", width: "100%" }}>
          <Tooltip
            PopperProps={{
              disablePortal: true,
            }}
            onClose={() => setTt(false)}
            open={tt}
            disableFocusListener
            disableHoverListener
            disableTouchListener
            title={"Try me!"}
            arrow
            placement="bottom"
            id={"try me"}
          >
            <Slider
              value={opacity}
              style={{ padding: "8px", width: "100%", boxSizing: "border-box" }}
              onChange={(event, newValue) => {
                setTt(false);
                setOpacity(newValue);
              }}
            />
          </Tooltip>
        </div>
        <Typography
          style={{
            minWidth: "86px",
            textAlign: "center",
            color: PRIMARYCOLOR,
            fontWeight: "bold",
          }}
        >
          {rightLabel}
        </Typography>
      </Flex>

      <Typography style={{ paddingTop: "16px" }}>
        {descriptionBottom}
      </Typography>
    </>
  );
};

export default DCMapOverlap;
